import React from 'react';
import { TextButton } from 'scy/buttons';
import { closeButton } from './styles.mod.scss';

export default function CloseButton({ onClick }) {
  return (
    <TextButton noUnderline className={closeButton} onClick={onClick}>
      ✕
    </TextButton>
  );
}
